import React from 'react';

import { SectionWrapper } from '@/components/common/Section';

import { ETabsColorVariant, ETabsVariant, Tabs } from '../../common/Hero/Tabs';
import { EscapesSearchWidget } from './EscapesSearchWidget';
import { Headline } from './Headline';
import css from './Hero.module.css';
import { HeroImage } from './HeroImage';

export const Hero: React.FC = () => {
  return (
    <SectionWrapper className="relative flex flex-col w-full h-full my-auto">
      <div className="flex justify-between pt-3 pb-5 lg:py-3">
        <div className="w-full">
          <Tabs tabVariant={ETabsVariant.Escapes} colorVariant={ETabsColorVariant.White} />
          <Headline />
        </div>
        <HeroImage />
      </div>
      <EscapesSearchWidget className={css.heroSearchWidget} />
    </SectionWrapper>
  );
};
